import { type RefObject, useCallback } from "react";
import { useResizable } from "@tellescope/ui";
import { useShallowSidebarStore, SIDEBAR_MAX_WIDTH, SIDEBAR_MIN_WIDTH } from "../../store/sidebar-store";

export const useSidebarPanel = (panelRef: RefObject<HTMLElement | null>) => {
  const {
    isOpen,
    width: storedWidth,
    setWidth,
    toggleIsOpen,
  } = useShallowSidebarStore("isOpen", "width", "setWidth", "toggleIsOpen");

  const computeSize = useCallback((e: MouseEvent) => window.innerWidth - e.clientX, []);

  const { onDragStart } = useResizable({
    elementRef: panelRef,
    property: "width",
    computeSize,
    minSize: SIDEBAR_MIN_WIDTH,
    maxSize: SIDEBAR_MAX_WIDTH,
    onResizeEnd: setWidth,
    enabled: isOpen,
  });

  return { isOpen, width: storedWidth, onDragStart, toggleIsOpen };
};
